
import React from 'react';
import ZNetwork from "./znetwork";
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZUtil from "./zutil";
import AMC  from './AMC';
import { APP } from './App';
import { ROUTER } from "./AMCRouter";
import PleaseStandBy from "./PleaseStandBy";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStreetView, faBars, faMousePointer, faTimes, faQuestion } from '@fortawesome/free-solid-svg-icons';
import AMCConstants from './AMCConstants';
import ZEaser from './zeaser';








// NEW 

var NINJA = {
	NINJA_VERSION: "0.01",
	init(context, callback) {
		ZNetwork.get("ninja", (err, result) => {
			if (err || !result.stats) {
				this.stats = {};
			} else {
				this.stats = result.stats;
			}
			this.history = [{ type: "ninja", value: "Yo, error loading the history of this conversation. But moving on...", level: "error" }];
			// DEPRECATED
			ZProps.set("ninja.stats", this.stats);
			callback(err, this);
		});
	},
	getButtonStat(stepuri) {
		return this.stats[stepuri] || 0;
	},
	pushHistory(h) {
		this.history.push(h);
		ZProps.set("ninja.history", Date.now());
	},
	getHistory() {
		return this.history;
	},
	setHistory(history) {
		this.history = history;
		ZProps.set("ninja.history", Date.now());
	},
	onHumanResponse(typed) {
		this.pushHistory({ type: "human", value: typed });
		this.pushHistory({ type: "ninja", value: typed + '? "If I only had a brain..."' });
	},
	gotoPage(url, callback) {
		ROUTER.pushRoute(url);
		//window.location.href = url;
		//APP.forceUpdate();
		//ZOO.forceUpdate();
		// delay so that we show the right tour for the right page. kludge fragile
		setTimeout( callback, 1000 );
	},
	gotoTour(tour) {
// done at button level		NINJA.recordStat(tour.uri);
			if (tour.rockstar) {
				let cookies = JSON.parse(ZUtil.getCandy("rockstar"))
				cookies.modes = cookies.modes || {};
				cookies.modes.rockstar = true;
				//cookies.modes.rockpile = true;
				ZUtil.setCandy("rockstar", JSON.stringify(cookies));
				//ZProps.set("ninja", "rockstar", true);
			}
			if (tour.rockstar) {
				let cookies = JSON.parse(ZUtil.getCandy("rockstar"))
				cookies.modes = cookies.modes || {};
				cookies.modes.rockstar = true;
				ZUtil.setCandy("rockstar", JSON.stringify(cookies));
				//ZProps.set("ninja", "rockstar", true);
			}
/*
			if (tour.expand) {
				let cookies = ZUtil.getCandy("zoo");
				cookies = cookies ? JSON.parse(cookies) : {};
				cookies.expanded = true;
				ZUtil.setCandy("zoo", JSON.stringify(cookies));
console.log("set ninja expanded: " + JSON.stringify(cookies));
				//ZProps.set("ninja", "expand", true);
			}
*/
		NINJA.gotoPage(tour.url, () => {
			setTimeout( () => {
			if (tour.expand) {
				ZProps.set("ninja", "expand", true);
			}
			if (tour.rockpile) {
				ZProps.set("ninja", "rockpile", true);
			}
			if (tour.inspector) {
				ZProps.set("ninja", "inspector", true);
			}
			NINJA.pushHistory({ type: "clear" });
			NINJA.pushHistory({ type: "ninja", value: tour.msg });
			ZLog.debug("gotoTour " + tour.url + ", page=" + tour.page);
			NINJA.pushHistory({ type: "widget", value: <ZNinjaTourWidget attr="data-hint" dictionary={HINTS} page={tour.page} /> });
			}, 10);
		});
	},
	thumb() {
//		return <img src="/images/frank.png" alt="friendly bot"/> 
		//return <FontAwesomeIcon icon={faUserNinja} />
		return <FontAwesomeIcon icon={faStreetView} />
	},
	thumbSVG() {
		return '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="street-view" class="svg-inline--fa fa-street-view fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"></path></svg>';
	},
	getWTF(element) {
		let path = window.location.pathname;
		let words = path.split("/");
		let page = words[1];
		let item = ZProps.get(words.slice(2).join("/"));
		let user = ZProps.get("user");
		let key = element.getAttribute("data-hint");
		return HINTS[page][key](user, item);
	},
	makeVisible(id) {
		let element = document.getElementById(id);
		if (element) {
			element.scrollIntoView(true);
		}
	},
	wiggleAt(id, duration = 2000) {
		let element = document.getElementById(id);
		if (element) {
			if (!NINJA.cursor) {
				NINJA.cursor = document.createElement("div");
				NINJA.cursor.className = "ZNinjaCursor";
//console.log("wiggler built cursor:" + id);
			}
			if (this.easer) {
				this.easer.stop();
			}
			let PATH_DURATION = 100;
			if (duration < PATH_DURATION) {
				return;
			}
			document.body.appendChild(NINJA.cursor);
			let bounds = element.getBoundingClientRect();
			let wiggle = window.innerWidth/10;
			let path = []
			for (let i = 0; i < duration; i+= PATH_DURATION * 2) {
				path.push( { x: bounds.left + Math.random() * wiggle/2, y: bounds.top + Math.random() * wiggle } );
				path.push( { x: bounds.left + bounds.width - Math.random() * wiggle/2, y: bounds.top + Math.random() * wiggle } );
			}
//console.log("wiggler starting easer :" + id);
			this._wiggle(path, PATH_DURATION, () => {
				document.body.removeChild(NINJA.cursor);
			});
		}
	},
	_wiggle(path, duration, callback) {
		this.easer = new ZEaser(
			function(k) {
//console.log("wiggler easer :" + k);
				let start = path[0];
				let end = path[1];
				NINJA.cursor.style.left = (start.x + k * (end.x - start.x)) + "px";
				NINJA.cursor.style.top = (start.y + k * (end.y - start.y)) + "px";
			}, function() {
				path.shift();
				if (path.length > 1) {
					NINJA._wiggle(path, duration, callback);
				} else {
					callback();
				}
			}, { duration: duration });
	},
	replaceVariables(str) {
		if (typeof str === "string") {
			let start = 0, index, end, variable;
			while ((index = str.indexOf("${", start)) !== -1) {
				start = index;
				end = str.indexOf("}", start);
				if (end !== -1) {
					variable = str.substring(start + "${".length, end);
					if (variable.length === str.length - "${".length - "}".length) {
						// handle functions that return non-strings
						return this.ninja.getVariable(variable);
					}
					str = str.substring(0, start) + this.ninja.getVariable(variable) + str.substring(start + variable.length + "${".length + "}".length);
				} else {
					str = str.substring(0, start) + str.substring(start + "${".length);
				}
			}
		}
		return str;
	},
	isPositiveResponse(str) {
		str = str.toLowerCase();
//console.log('["yes", "y", "yep", "ok", "ya", "yeah"].indexOf(str)=' + (["yes", "y", "yep", "ok", "ya", "yeah"].indexOf(str)));
		return ["yes", "y", "yep", "ok", "ya", "yeah"].indexOf(str) !== -1;
	},
	isNegativeResponse(str) {
		str = str.toLowerCase();
		return ["no", "n", "nope", "nada"].indexOf(str) !== -1;
	},
	getShortPageDescription() {
		let URL_TO_PAGE = { zoo: "Zoo profile page", rockstar: "Rockstar IDE", leaderboards: "Zoo leaderboards page" };
		let path = window.location.pathname;
		ZLog.debug("getShortPageDescription path=" + path);
		if (path === "/") {
			return "the automatic.ai home page";
		}
		let words = path.split("/");
		let page = URL_TO_PAGE[words[1]] || words[1]
		if (!words[2]) {
			return "the " + page;
		}
		let owner = words[2] === "core" ? "Automatic.ai" : words[2];
		let kind = words[3];
		let user = ZProps.get("user");
		return "the " + page + " for a " + kind + " built by " + (owner === user.uri ? "you" : owner);
	},
	displayHint(element, text, nav, disableMakeVisible) {
		if (!disableMakeVisible) {
			element.scrollIntoView(true);
		}
		if (!this.hint_element) {
			this.hint_element = document.createElement("div");
			this.hint_element.className = "ZNinjaHint";
			this.hint_element_focus = document.createElement("div");
			this.hint_element_focus.className = "ZNinjaHintFocus";
			this.hint_element_focus.innerHTML = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-alt-circle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-arrow-alt-circle-down fa-w-16 fa-3x"><path fill="currentColor" d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z" class=""></path></svg>';
		}
		let side = "top"
//		let bounds = ZUtil.getBoundingClientRect(element, "parent");
		let bounds = element.getBoundingClientRect();
		let FOCUS_RADIUS = 30;
		this.hint_element.innerHTML = '<div class="ZNinjaHintCloseButton" id="zninja-hint-close-button"><img src="/images/close.png" /></div><div class="ZNinjaHint' + side + 'ArrowBorder"></div><div class="ZNinjaHint' + side + 'Arrow"></div><div class="ZNinjaHintContent"><div class="ZNinjaHintThumb">' + NINJA.thumbSVG() + '</div>' + text + '</div>';
		if (nav) {
			this.hint_element.onclick = function() { nav.next() };
		}
		switch (side) {
			default:
				ZLog.warn("Unsupported location for hint: " + side);
				// falls through
			case "top" :
				this.hint_element.style.left = (bounds.left + bounds.width/2) + "px";
				// this.hint_element.style.top = (bounds.top + bounds.height/2 - MARGIN - FOCUS_RADIUS*3) + "px";
				// this.hint_element.style.bottom = (window.innerHeight - bounds.top + MARGIN) + "px";
				//this.hint_element.style.top = (bounds.top + bounds.height/2 - 2.5*MARGIN) + "px";
				//this.hint_element.style.bottom = (bounds.bottom + (bounds.height > 4 * MARGIN ? bounds.height/2 : 0) + 2*MARGIN) + "px";
				this.hint_element.style.bottom = ( window.innerHeight - (bounds.top + bounds.height/2 - 2*FOCUS_RADIUS) ) + "px";
				break;

		}
		this.hint_element_focus.style.left = (bounds.left + bounds.width/2 - FOCUS_RADIUS) + "px";
		this.hint_element_focus.style.top = (bounds.top + bounds.height/2 - 2*FOCUS_RADIUS) + "px";
		document.body.appendChild(this.hint_element);
		document.body.appendChild(this.hint_element_focus);
		document.getElementById("zninja-hint-close-button").onclick = (e) => { e.preventDefault(); e.stopPropagation(); this.closeHints(); return false; };
	},
	closeHints() {
		if (this.hint_element) {
			document.body.removeChild(this.hint_element);
			document.body.removeChild(this.hint_element_focus);
			// don't try to remove this again...
			this.hint_element = null;
		}
	},
	isPointing() {
		return this.pointing;
	},
	togglePointer() {
		this.pointing = !this.pointing;
		if (this.pointing) {
			if (!this.pointer) {
				this.pointer = document.createElement("div");
				this.pointer.className = "ZNinjaPointer";
//				this.pointer.innerHTML = '<i class="fas fa-mouse-pointer"></i>';
//				this.pointer.innerHTML = '<i class="fas fa-question"></i>';
				this.pointer.innerHTML = '<img src="/images/sunglasses-2.png" />';
			}
			let clickables = [];
			let elements = document.getElementsByTagName("*");
			for (let i = 0; i < elements.length; ++i) {
				let e = elements[i];
				if (e.getAttribute && e.getAttribute("data-hint")) {
					clickables.push(e);
				}
			}
			this.pointer_handler = new WTFPointer(this.pointer, clickables, 
				(clicked) => { 
					if (clicked) {
						this.displayHint(clicked, this.getWTF(clicked));
					} else {
						this.closeHints();
					}
				}, 
				(hovered) => { 
					if (hovered !== this.pointer_hovered) {
						if (this.pointer_hovered) {
							ZUtil.removeClassname(this.pointer_hovered, "WTFPointerTarget");
						}
						this.pointer_hovered = hovered;
						if (this.pointer_hovered) {
							ZUtil.addClassname(this.pointer_hovered, "WTFPointerTarget");
						}
					}
				}).enable(); 
		} else {
			if (this.pointer_handler) {
				this.pointer_handler.disable();
				if (this.pointer_hovered) {
					ZUtil.removeClassname(this.pointer_hovered, "WTFPointerTarget");
					this.pointer_hovered = null;
				}
			}
		}
	}
}
function WTFPointer(pointer, clickables, onClick, onHover) {
    this.pointer = pointer;
    this.clickables = clickables;
    this.onClick = onClick;
    this.onHover = onHover;
    ZUtil.bindHandlers(this);
}

WTFPointer.prototype = {
    enable: function () {
	document.addEventListener('mousemove', this._onMove, false);
	document.addEventListener('mouseup', this._onMouseUp, false);
	document.addEventListener('touchend', this._onTouchEnd, false);
	document.body.appendChild(this.pointer);
	return this;
    },

    disable: function () {
	document.removeEventListener('mousemove', this._onMove, false);
	document.removeEventListener('mouseup', this._onMouseUp, false);
	document.removeEventListener('touchend', this._onTouchEnd, false);
	document.body.removeChild(this.pointer);
    },

    _onMove: function (e) {
        e.preventDefault();
	e.stopPropagation();
        var pos = ZUtil.getMousePosition(e, document.body);
       	this.pointer.style.left = (pos[0] - this.pointer.offsetWidth/2) + "px";
       	this.pointer.style.top = (pos[1] - this.pointer.offsetHeight/2) + "px";
	var target = ZUtil.pickElement(this.clickables, pos[0], pos[1]);
	this.onHover(target);
    },

    _onUp: function (e) {
        e.preventDefault();
	e.stopPropagation();
        var pos = ZUtil.getMousePosition(e, document.body);
	var target = ZUtil.pickElement(this.clickables, pos[0], pos[1]);
	this.onClick(target);
    },

    _onMouseUp: function (e) {
        this._onUp(e);
    },

    _onTouchEnd: function (e) {
        this._onUp(e);
    },
	
};

/* eslint-disable no-template-curly-in-string */
var TOURS = {
	"Zoo profile": { url: "/zoo/core/service/example-sklearn-housing-price-predictor", disableMakeVisible: true, msg: "Cool. This is the list of tour stops for this page", uri: "Zoo profile" }, 
	"Rockstar": { url: "/zoo/core/service/example-sklearn-housing-price-predictor", disableMakeVisible: true, expand: true, rockstar: true, inspector: true, rockpile: true, page: "Rockstar", msg: "Welcome to the rockstar IDE tour", uri: "Rockstar" },
	"Zoo": { url: "/", uri: "Zoo" },
};
var HINTS = {
		title: (user, item) => { return `This is the title of this ${item.kind}. If you are the owner of this, and you ${item.owner === user.uri ? "are" : "are not (" + item.owner + " is the owner)"}, you can edit the title by opening up Rockstar's inspector and using the 'properties' tab` },
		player: (user, item) => { return `Click the play button to open the player, a simple HTML user interface for the service that allows you to exercise it's functionality.` },
		rockpile: (user, item) => { return `This button opens and closes the 'Rockpile', the area that lists drag-and-droppable components (rocks) to build your services with` },
		play: (user, item) => { return `This button opens the demonstration UI that exercises the service` },
		compute: (user, item) => { return `This button displays the amount of compute you have left. Click it to open the form to expand your capacity or increase your service's speed` },
		rockstar: (user, item) => { return `This button opens and closes the Rockstar editor itself` },
		expand: (user, item) => { return  `This button toggles the Rockstar editor size between fullscreen and embedded screen` },
		owned: (user, item) => { return  `This button shows whether you are a member of the group that owns this service` },
		share: (user, item) => { return  `Share a link to this page with others on social networks or email` },
		"service api": (user, item) => { return  `An example of how to call this service's api` },
		"standalone link": (user, item) => { return  `The URL of the demo page for this service` },
		"parts list": (user, item) => { return  `The list of components used by this service` },
		"users": (user, item) => { return  `The list of services using this` },
		leaderboards: (user, item) => { return "Lists of the best and most popular everythings" },
		"train pipeline": (user, item) => { return "This is the training pipeline. It contains the components that load data and process the data and the smart algorithm that eventually uses the data to build the model that encapsulates knowledge about the patterns in the data" },
		"test pipeline": (user, item) => { return "This is the testing pipeline. It contains the components that load test data and process the data and the algorithm using the previously trained model to makes predicitons and compares them to known correct answers to determine accuracy of the model" },
		"production pipeline": (user, item) => { return "This is the production pipeline. It contains the components that load data and process the data and the smart algorithm that makes predictions about the data" },
		model: (user, item) => { return "This is the model. It contains the pipelines that train  and test (validate) the model" },
		service: (user, item) => { return "This is the service. It contains the model and the components that deploy and create the demo UI and the production pipeline that makes predictions" },
		"the rockpile": (user, item) => { return "This is the Rockpile. Drag and drop components from here onto your Service." },
		"todo list": (user, item) => { return "This lists the next steps towards building and deploying your service. The next, top action item is clickable" },
		"editor": (user, item) => { return "The right mouse button (or long left-mouse or tap) opens the main context menu. This allows you to open the inspector, expand and collapse the graph, etc." },
}

class ZNinjaWelcomeWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let path = window.location.pathname;
		let words = path.split("/");
		let page = words[1];
		let kind = words[3];
		let buttons = [];
		if (page === "zoo") {
			buttons.push({ label: "Page overview", uri: page + ":pageoverview" });
			if (kind === "service") {
				buttons.push({ label: "Rockstar overview", uri: "rockstaroverview" });
//				buttons.push({ label: "Show me what to do", uri: page + ":whattodo" });
			}
		} else {
			buttons.push({ label: "List tours", uri: "listtours" });
			buttons.push({ label: "List tutorials", uri: "listtutorials" });
			buttons.push({ label: "Just mess around a bit", uri: "messaround" });
		}
		buttons.forEach( b => b.stat = NINJA.getButtonStat(b.uri) || 0 );
		this.setState({ buttons: buttons });
	}
	onClick = (button) => {
		//NINJA.recordStat(button.uri);
		AMC.track(button.uri);
		switch (button.uri) {
			case "rockstaroverview": 
				NINJA.gotoTour(TOURS["Rockstar"]);
				//NINJA.pushHistory({ type: "ninja", value: "Cool. This is the list of hints for the Rcokstar overview" });
				//NINJA.pushHistory({ type: "widget", value: <ZNinjaTourWidget attr="data-hint" dictionary={HINTS} /> });
				break;
			default :
				// falls through
			case "pageoverview": 
				NINJA.pushHistory({ type: "ninja", value: "Cool. This is the list of hints for the page overview" });
				NINJA.pushHistory({ type: "widget", value: <ZNinjaTourWidget attr="data-hint" dictionary={HINTS} /> });
				break;
			case "listtours" :
				NINJA.pushHistory({ type: "ninja", value: "Great choice. This is the list of tours for this app" });
				NINJA.pushHistory({ type: "widget", value: <ZNinjaToursWidget dictionary={TOURS} /> });
				break;
			case "listtutorials" :
				break;
			case "messaround" :
				NINJA.pushHistory({ type: "ninja", value: "Cool. Have at it." });
				break;
		}
		this.forceUpdate();
	}
	render() {
		let { buttons } = this.state;
		buttons = buttons || [];
		buttons.forEach( b => b.stat = NINJA.getButtonStat(b.uri) || 0 );
		return (
			<ZNinjaButtonList buttons={buttons} onClick={this.onClick} echo={true} />
		);
	}
}

class ZNinjaTourWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { attr, dictionary, page } = this.props;
		let path = window.location.pathname;
		//page = page || path.split("/")[1];
		page = page || ZProps.get("pagename");
		let elements = document.getElementsByTagName("*");
		let stops = [];
		let index = 0;
		let item = ZProps.get(path.split("/").slice(2).join("/"));
		let user = ZProps.get("user");
		for (let i = 0; i < elements.length; ++i) {
			let e = elements[i];
			let key = e.getAttribute && e.getAttribute(attr);
			if (key) {
				if (!dictionary[key]) {
					ZLog.error("Do not know how to translate hint: " + key);
				} else {
					stops.push({ label: key, uri: page + ":" + key, element: e, message: dictionary[key](user, item), index: index++ });
				}
			}
		}
		this.setState({ stops: stops });
	}
	gotoStop = (stop) => {
		if (!stop) {
			stop = this.state.stops[0];
		}
		AMC.track(stop.uri);
		// NINJA.recordStat(stop.uri);
		NINJA.displayHint( stop.element, stop.message, { next: () => { this.gotoStop(this.state.stops[stop.index + 1]) } }, TOURS[ZProps.get("pagename")].disableMakeVisible );
		this.forceUpdate();
	}
	render() {
		let { stops } = this.state;
		stops = stops || [];
//ZLog.log("before stops=" , { stops: stops });
		stops.forEach( s => s.stat = NINJA.getButtonStat(s.uri) );
//ZLog.log("stops=" , { stops: stops });
//		let buttons = (stops || []).map( stop => <ZNinjaButton key={stop.label} onClick={e => this.gotoStop(stop)} label={stop.label} stat={NINJA.getButtonStat(stop.uri)} /> );
//				{buttons}
		return (
			<div className="ZNinjaNinjaBubble">
				{ stops.length === 0 ? "<none>" : <ZNinjaButtonList buttons={stops} onClick={this.gotoStop} /> }
			</div>
		)
	}
}

class ZNinjaToursWidget extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { dictionary } = this.props;
		let tours = Object.keys(dictionary).map( key => { return { label: key, uri: "tour:" + key, url: dictionary[key].url }  } );
		this.setState({ tours: tours });
	}
/*
	gotoTour = (tour) => {
		NINJA.recordStat(tour.uri);
		NINJA.gotoPage(tour.url, () => {
			NINJA.pushHistory({ type: "ninja", value: "Cool. This is the list of tour stops for this page" });
			NINJA.pushHistory({ type: "widget", value: <ZNinjaTourWidget attr="data-hint" dictionary={HINTS} /> });
		});
	}
*/
	render() {
		let { tours } = this.state;
		tours = tours || [];
		tours.forEach( s => s.stat = NINJA.getButtonStat(s.uri) );
		return (
			<div className="ZNinjaNinjaBubble">
				{ tours.length === 0 ? "<none>" : <ZNinjaButtonList buttons={tours} onClick={NINJA.gotoTour} echo={true} /> }
			</div>
		)
	}
}

class ZNinjaButtonList extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	onClick = (button) => {
		let { echo } = this.props;
		if (echo) {
			NINJA.pushHistory({ type: "user", value: button.label });
		}
		this.props.onClick(button);
		this.forceUpdate();
	}
	render() {
		let { buttons } = this.props;
//console.log("key list=" + "list" + buttons.map( b => b.label + "-" + b.uri + "--" + b.stat ).join(","));
//			<div className="ZNinjaNinjaBubble" key={"list" + buttons.map( b => b.label + "-" + b.stat ).join(",")}>
		return (
			<div className="ZNinjaNinjaBubble">
				{buttons.map( button => { return <ZNinjaButton key={button.label} onClick={this.onClick} button={button} /> } )}
			</div>
		);
	}
}
				
class ZNinjaButton extends React.Component {
	render() {
		let { onClick, button } = this.props;
		return (
			<button key={button.label + ":" + button.stat} onClick={e => onClick(button)}>
				{ button.label }
				{ button.stat !== undefined ? <span className="ZNinjaButtonRightSide">{ button.stat }</span> : '' }
			</button>
		);
	}
}


export default class ZNinja extends React.Component {
	constructor(props) {
		super(props);
		this.atbottom = true;
		this.state = { };
	}
	componentDidMount() {
		let { context } = this.props;
		NINJA.init(context, (err, ninja) => {
			this.welcomeUserToPage(ZProps.get("path"));
			this.setState({ loaded: true });
		});
		this.listener = ZProps.addListener("path", (name, value, oldvalue) => {
			NINJA.closeHints();
			this.welcomeUserToPage(value);
		});
		this.listener2 = ZProps.addListener("ninja.history", (name, value, oldvalue) => {
			this.forceUpdate();
			this.atbottom = true;
		});
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
		ZProps.removeListener(this.listener2);
		NINJA.closeHints();
	}
	welcomeUserToPage(path) {
		ZLog.debug("welcomeUserToPage: " + path);
		NINJA.pushHistory({ type: "clear" });
		NINJA.pushHistory({ type: "ninja", value: `This is ${NINJA.getShortPageDescription()}. What do you want to do now?`, level: "question" });
		NINJA.pushHistory({ type: "widget", value: <ZNinjaWelcomeWidget /> });
//		NINJA.pushHistory({ type: "ninja", value: [{type: "text", value: "What do you want to do now?" }, { type: "widget", value: <ZNinjaWelcomeWidget /> });
		this.forceUpdate();
	}
	onHumanResponse = (response) => {
		ZLog.debug("ZNinja.onHumanResponse:" + response);
		NINJA.onHumanResponse(response);
		this.setState({ thinking: true });
		setTimeout(() => { this.setState({ thinking: false }) }, 250); // 2000 + Math.random(500));
	}
	onScroll(e) {
		var HYSTERESIS = 30;
		this.atbottom = Math.abs(e.target.offsetHeight + e.target.scrollTop - e.target.scrollHeight) < HYSTERESIS;
	}
	scrollToBottom() {
		if (this.atbottom) {
			let scrollable = document.getElementById("zninja_content_area")
			if (scrollable) {
				scrollable.scrollTop = scrollable.scrollHeight;
			}
		}
	}
	onKeyUp(event) {
		var key = event.key
		if (key === 'Enter') {
			this.onHumanResponse(event.target.value.trim(), null);
			event.target.value = "";
		} else {
			this.autoResizeTextarea(event.target);
		}
	}
	autoResizeTextarea(textarea) {
		setTimeout(function() {
			let height = textarea.scrollHeight;
			textarea.style.cssText = 'height:auto; padding:0';
			textarea.style.cssText = 'height:' + height + 'px';
			document.getElementById("zninja_content_area").style.bottom = height + "px";
		}, 0);
	}
	toggleMenu(flag) {
		let history = NINJA.getHistory();
		let withouts = history.filter( h => h.id !== "menu" );
		if (withouts.length !== history.length) {
			NINJA.setHistory(withouts);
		} else {
			NINJA.pushHistory({ type: "ninja", value: "TOURS AND TUTORIALS AVAILABLE", id: "menu" });
			NINJA.pushHistory({ type: "widget", value: <ZNinjaToursWidget dictionary={TOURS} />, id: "menu" });
		}
	}
	toggleAbout(flag) {
		let history = NINJA.getHistory();
		let withouts = history.filter( h => h.id !== "about" );
		if (withouts.length !== history.length) {
			NINJA.setHistory(withouts);
		} else {
			NINJA.pushHistory({ type: "clear", id: "about" });
			NINJA.pushHistory({ type: "ninja", value: `Automatic Ninja ${NINJA.NINJA_VERSION}. I am here to help you become a kickass rockstar ninja AI guru. Please let my humans know if you would want them to hurry up and open up my brain so everyone can operate on me and help me to do smarter things than this crummy scripted interface here. That's not too smart yet, either - just look at my poor sad version number!`, id: "about" });
			NINJA.pushHistory({ type: "ninja", value: "BTW, not to anthropomorphize myself or anything, but I also want to be the biggest, baddest machine-learning AGI-making ninja the world has ever seen. Yes, I'm a bot. But someday....", id: "about" });
			NINJA.pushHistory({ type: "widget", value: <div className="ZNinjaNinjaBubbleWithEmbeddedElements">Click on {<FontAwesomeIcon icon={faBars} />} for options, {<FontAwesomeIcon icon={faMousePointer} />} to ask questions by clicking on stuff, {<FontAwesomeIcon icon={faQuestion} />} to toggle info about this bot, and <FontAwesomeIcon icon={faTimes} /> to close this panel</div>, id: "about" });
			// NINJA.pushHistory({ 	[{ type: "text", value: "Tours", level: "header"}, { type: "menu", value: "${NINJA_TOURS}" }, { type: "text", value: "Tutorials", level: "header"}, { type: "menu", value: "${NINJA_TUTORIALS}" }],
		}
	}
	togglePointer() {
		NINJA.togglePointer();
		this.forceUpdate();
	}
	render() {
		ZLog.debug("RENDER ninja");
		let { loaded, thinking } = this.state;
		if (!loaded) {
			return (
				<div className="ZNinja">
					<PleaseStandBy />
				</div>
			);
		}
		let history = NINJA.getHistory();
		history = history.slice(Math.max(0, history.length - 100));
		ZLog.debug("RENDER ninja", { history: history});
		let clear_at = -1;
		for (let i = 0; i < history.length; ++i) {
			if (history[i].type === "clear") {
				clear_at = i;
			}
		}
		if (clear_at !== -1) {
			history = history.slice(clear_at + 1);
		}
		if (thinking) {
			history.pop();
			history.push({ type: "thinking" });
		}
		let dialog = history.map( (s, index) => {
//ZLog.trace("RENDER ninja history step: ", { s: s });
			if (s.type === "ninja") {
				return <ZNinjaBubble key={"n" + index} response={s.value} level={s.level} />;
		 	} else if (s.type === "thinking") {
				return <ZNinjaBubble key={"n" + index} thinking={true} response={s.value} />;
		 	} else if (s.type === "widget") {
				return <div key={"n" + index} className="ZNinjaEmbeddedWidget">{ s.value }</div>
		 	} else if (s.type === "clear") {
				return '';
			} else { // type === "human"
				return (
					<div key={"h" + index} className="ZNinjaWidget ZNinjaUserWidget">
						<div className="ZNinjaUserBubble">{s.value}</div>
					</div>
				)
			}
		} );
		return (
			<div className="ZNinja">
				<div className="RockPanelControls">
					<div className="ZNinjaTopBarButton" onClick={this.toggleMenu.bind(this)}><FontAwesomeIcon icon={faBars} /></div>
					<div className={"ZNinjaTopBarButton" + (NINJA.isPointing() ? " ZNinjaTopBarButtonActive" : "")} onClick={this.togglePointer.bind(this)}><FontAwesomeIcon icon={faMousePointer} /></div>
					<div className="ZNinjaTopBarButton ZNinjaTopBarButtonRightSide ZNinjaTopBarButtonClose" onClick={e => APP.toggleNinja(false)}><FontAwesomeIcon icon={faTimes} /></div>
					<div className="ZNinjaTopBarButton ZNinjaTopBarButtonRightSide" onClick={this.toggleAbout}><FontAwesomeIcon icon={faQuestion} /></div>
				</div>
				<div className="ZNinjaContent" id="zninja_content_area" onScroll={this.onScroll.bind(this)}>
					{dialog}
				</div>
				<div className="ZNinjaUserTextarea">
					<textarea id="zninja_textarea" rows="1" onKeyUp={this.onKeyUp.bind(this)} placeholder="Talk to the app" />
				</div>
			</div>
		)
	}
	componentDidUpdate() {
		if (document.getElementById("zninja_textarea")) {
			this.autoResizeTextarea(document.getElementById("zninja_textarea"));
		}
		setTimeout( () => { this.scrollToBottom() }, 100 );
	}
}

class ZNinjaBubble extends React.Component {
	render() {
		let { thinking, response, level } = this.props;
		return (
			<div className="ZNinjaWidget ZNinjaNinjaWidget">
				<div className={"ZNinjaNinjaBubble ZNinjaNinjaBubble" + (level || "")}>{NINJA.thumb()}
					{ thinking ? 
						<span className="ZNinjaStepBubbleThinking"><img alt="waiting" src="/images/wait.gif" /></span>
					:
						<span className={"ZNinjaNinjaBubble" + (level || "")}>{response}</span>
					}
				</div>
			</div>
		);
	}
}

export class ZooNinjaButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = { selected: this.props.selected };
	}
	componentDidMount() {
		this.listener = ZProps.addListener(AMCConstants.TRACKINGS_LOADED, (name, value, oldvalue) => {
			this.forceUpdate();
		});
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
	}
	launch() {
		let { context } = this.props;
		AMC.track(context);
		if (ZProps.get("beta")) {
			return this.setState({ label_override: "Beta requires sign in first" });
		}
		APP.toggleNinja(true, context);
		NINJA.init(context, (err, ninja) => {
			ninja.gotoTour(TOURS[context]);
		});
	}
	render() {
		let { label, context } = this.props;
		let { selected, label_override } = this.state;
		let count = ZUtil.toShortCount(ZProps.get(context) || 0);
		return (
			<div className={"ZooNinjaButton HScoreButton" + (selected ? " ZooNinjaButtonSelected" : "")} onClick={this.launch.bind(this)}>
			<div className="HScoreButtonLabel" aria-label="Request that the ninja make an appearance">
				{NINJA.thumb()}
				{label_override || label}
			</div>
			<div className="HScoreButtonCount" aria-label={count + " people used this option"}>{count}</div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZNinja.js